module.exports = __webpack_public_path__ + "img/CONSIGUE.034671a2.png";